import React from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import rawMatIcon from "../../../../../assets/new-product-detail-cats/header-icons/raw-material-icon.svg";
import { useTranslation } from "react-i18next";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";

const RawMaterialIcon = () => (
  <img src={rawMatIcon} alt="Manufacturing Icon" width={76} height={76} />
);

const RawMaterialHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  totalProdItem,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <CategoryComponent
      show={show}
      className={`prod-manufacturing-category ${className || ""}`}
      leftBoxProps={{
        icon: <RawMaterialIcon />,
        title: t("MANUFACTURING_PROCESSES"),
        description: t("MANUFACTURING_PROCESSES_DESC"),
        productId: productId,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: t("EMISSIONS"),
                subitems: [
                  {
                    value: `${
                      totalProdItem
                        ? handleToFixedNum(
                            totalProdItem,
                            totalProdItem?.total_carbon
                          )
                        : "xx"
                    } (tCO₂e)`,
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalProdItem?.updated_at
          ? formatDate(totalProdItem?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default RawMaterialHeader;
